import React, { useState } from "react";
import Searchbar from "./Searchbar";
import MusicCards from "./MusicCards";
import { Link } from "react-router-dom";

function Home() {
  const [searchedSongs, setSearchedSongs] = useState([]);
  return (
    <div className="App">
      {!searchedSongs.length ? (
        <div>
          <h1 className="mt-title"> Me♪o </h1>

          <Searchbar setSearchedSongs={setSearchedSongs} />
          <br />
          <Link to="/melo/docs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              fill="currentColor"
              className="bi bi-question-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
            </svg>
          </Link>
        </div>
      ) : (
        <div>
          <a href="/melo">
            <h1 className="title">Me♪o</h1>
          </a>
          <Searchbar setSearchedSongs={setSearchedSongs} />
          <MusicCards searchedSongs={searchedSongs} />
        </div>
      )}
    </div>
  );
}

export default Home;
